import React, { Fragment, useState } from 'react';
import { 
	IconButton, 
	Drawer, 
	Divider, 
	List, 
	ListItem, 
	ListItemIcon, 
	ListItemText, 
	Slide, 
	Fab,
	Zoom } from '@material-ui/core';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MenuIcon from '@material-ui/icons/Menu';
import './Header.scss';
import Book from '../Book/Book';

import { makeStyles } from '@material-ui/core/styles';
import AboutIcon from '@material-ui/icons/Info';
import GalleryIcon from '@material-ui/icons/PhotoLibrary';
import ResortInfoIcon from '@material-ui/icons/Spa';
import CalendarIcon from '@material-ui/icons/Event';
import ContactUsIcon from '@material-ui/icons/Mail';
import { Link } from 'react-router-dom';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },

	scrollTop: {
		position: 'fixed',
		bottom: theme.spacing(2),
		right: theme.spacing(2),
	},
	secondary: {
		backgroundColor: '#ff7e44',
		'&:hover': {
			backgroundColor: '#f25a15'
		}
	},
  menuButton: {
	marginRight: '16px',
	marginLeft: '16px',
	'&:hover': {
		'& svg': {
			color: '#9cdcfe'
		},
		backgroundColor: '#282935',
	}
  },
  drawer: {
    width: drawerWidth,
	flexShrink: 0,
	'& a': {
		textDecoration: 'none'
	}
  },
  drawerPaper: {
	width: drawerWidth,
	backgroundColor: '#252526',
	color: 'white'
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
	justifyContent: 'flex-end',
	'& svg': {
		color: 'white'
	},
	'&:hover': {
		'& svg': {
			color: '#9cdcfe'
		}
	}
  },
  button: {
	'&:hover': {
		backgroundColor: '#37373d',
		color: '#9cdcfe',
		'& svg': {
			color: '#9cdcfe'
		}
	},
  }
}));

const HideOnScroll = (props) => {
	const { children } = props;
	const trigger = useScrollTrigger();
  
	return (
		  <Slide appear={false} direction="down" in={!trigger}>
			{children}
		  </Slide>
	);
}

const ScrollTop = (props) => {
	const { children } = props;
	const classes = useStyles();
	const trigger = useScrollTrigger();
  
	const handleClick = (event) => {
		const anchor = (event.target.ownerDocument || document).querySelector('#carousel-top');
	  	if (anchor) {
			anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
	  	}
	};
  
	return (
		<Zoom in={trigger}>
			<div onClick={handleClick} role="presentation" className={classes.scrollTop}>
				{children}
			</div>
		</Zoom>
	);
}

const Header = (props) => {
	const classes = useStyles();
	const [open, setOpen] = useState(false);

	const handleMenuOpen = () => {
		setOpen(true)
	}

	const handleMenuClose = () => {
		setOpen(false)
	}

  	return (
		<Fragment>
			<HideOnScroll {...props}>
				<div className="header">
					<IconButton className={classes.menuButton} onClick={handleMenuOpen}>
						<MenuIcon fontSize="large" />
					</IconButton>
					<div className="grow" />
					<Book />
				</div>
			</HideOnScroll>
			<ScrollTop {...props}>
				<Fab color="secondary" classes={{secondary: classes.secondary}}>
					<KeyboardArrowUpIcon />
				</Fab>
			</ScrollTop>
			<Drawer
					className={classes.drawer}
					variant="persistent"
					anchor="left"
					open={open}
					classes={{ paper: classes.drawerPaper }}
			>
				<div className={classes.drawerHeader}>
					<IconButton onClick={handleMenuClose}>
						<ChevronLeftIcon />
					</IconButton>
				</div>
     			<Divider />
				 <nav>
					<List>
						<Link to="/about" smooth="true" className="link">
							<ListItem button key={"About"} classes={{button: classes.button}}>
								<ListItemIcon><AboutIcon className="icon" /></ListItemIcon>
								<ListItemText primary={"About"} className="listItemText" />
							</ListItem>
						</Link>
						<Link to="/gallery" smooth="true" className="link">
							<ListItem button key={"Gallery"} classes={{button: classes.button}}>
								<ListItemIcon><GalleryIcon /></ListItemIcon>
								<ListItemText primary={"Gallery"} className="listItemText" />
							</ListItem>
						</Link>
						<Link to="/resortinfo" smooth="true" className="link">
							<ListItem button key={"ResortInfo"} classes={{button: classes.button}}>
								<ListItemIcon><ResortInfoIcon /></ListItemIcon>
								<ListItemText primary={"Resort Info"} className="listItemText" />
							</ListItem>
						</Link>
						<Link to="/calendar" smooth="true" className="link">
							<ListItem button key={"Calendar"} classes={{button: classes.button}}>
								<ListItemIcon><CalendarIcon /></ListItemIcon>
								<ListItemText primary={"Available Dates"} className="listItemText" />
							</ListItem>
						</Link>
						<Link to={"contactus"} smooth="true" className="link">
							<ListItem button key={"ContactUs"} classes={{button: classes.button}}>
								<ListItemIcon><ContactUsIcon /></ListItemIcon>
								<ListItemText primary={"Contact Us"} className="listItemText" />
							</ListItem>
						</Link>
					</List>
				</nav>
   			</Drawer>
    	</Fragment>
  	);
}

export default Header;